// Slow Match Alert Component
//
// Displays warnings for matches that are running over their estimated time

import React, { useState, useEffect } from 'react';
import { getSlowMatches, formatMinutes } from '../../utils/matchTimingUtils';

export default function SlowMatchAlert({ bracket, tournament, isMobile = false }) {
  const [slowMatches, setSlowMatches] = useState([]);

  useEffect(() => {
    // Initial check
    const checkSlowMatches = () => {
      const slow = getSlowMatches(bracket, tournament);
      setSlowMatches(slow);
    };

    checkSlowMatches();

    // Update every minute
    const interval = setInterval(checkSlowMatches, 60000);

    return () => clearInterval(interval);
  }, [bracket, tournament]);

  if (slowMatches.length === 0) {
    return null;
  }

  return (
    <div style={{
      padding: isMobile ? '10px' : '12px',
      backgroundColor: 'var(--warning-bg)',
      border: '2px solid var(--warning)',
      borderRadius: '6px',
      marginBottom: '12px'
    }}>
      <div style={{
        fontWeight: 'bold',
        marginBottom: '8px',
        fontSize: isMobile ? '13px' : '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <span>⚠️</span>
        <span>Slow Matches ({slowMatches.length})</span>
      </div>

      <div style={{ fontSize: isMobile ? '12px' : '13px' }}>
        {slowMatches.map(({ match, elapsedMinutes }) => (
          <div
            key={match.id}
            style={{
              marginBottom: '6px',
              padding: '6px',
              backgroundColor: 'var(--bg-secondary-50)',
              borderRadius: '4px'
            }}
          >
            <div style={{ fontWeight: '500', marginBottom: '2px' }}>
              {match.table && (
                <span style={{
                  display: 'inline-block',
                  backgroundColor: 'var(--warning-dark)',
                  color: '#fff',
                  padding: '2px 6px',
                  borderRadius: '3px',
                  fontSize: isMobile ? '11px' : '12px',
                  marginRight: '6px',
                  fontWeight: 'bold'
                }}>
                  Table {match.table}
                </span>
              )}
              {match.p1.name} vs {match.p2.name}
            </div>
            <div style={{ color: 'var(--warning-dark)', fontSize: isMobile ? '11px' : '12px' }}>
              Running: {formatMinutes(elapsedMinutes)}
            </div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: '8px',
        fontSize: isMobile ? '11px' : '12px',
        color: 'var(--warning-dark)',
        fontStyle: 'italic'
      }}>
        💡 Tip: Check on these matches to ensure they're progressing
      </div>
    </div>
  );
}
